import { InsuranceParamsType, Product } from 'BrokerTsLib/src/enums'

import { useAuth } from '@/context/AuthContext'
import { usePartner } from '@/context/PartnerContext'

import { useApp } from './useApp'

/**
 * Returns set of supported insurance params types
 * @returns 
 */
export const useGetInsuranceParamsTypes = (): InsuranceParamsType[] => {
  const { currentPartner } = usePartner()
  const { user } = useAuth()
  const { product } = useApp()

  if (product === Product.VehicleInsurance || product === Product.VehicleLeasingInsurance || product === Product.FleetInsurance) {
    switch (currentPartner?.partner) {
      case 'Essox':
      case 'AutoEsa':
      case 'DirectAuto':
        return user?.enablePoleasEssox ?
          [
            InsuranceParamsType.Basic,
            InsuranceParamsType.AddOn,
            InsuranceParamsType.Poleas,
            InsuranceParamsType.Poleas2
          ]
          :
          [
            InsuranceParamsType.Basic,
            InsuranceParamsType.AddOn
          ]

      case 'Kapitol':
        return [
          InsuranceParamsType.Basic,
          InsuranceParamsType.AddOn,
        ]
      case 'Jap':
        return [
          InsuranceParamsType.Basic,
          InsuranceParamsType.AddOn
        ]
      case 'Cebia':
        return [
          InsuranceParamsType.Basic,
          InsuranceParamsType.AddOn
        ]
    }
  }

  return [InsuranceParamsType.Basic]
}